import { createAction, nanoid } from "@reduxjs/toolkit";

import type { Location, Params } from "react-router";

/**
 * Dispatched on every navigation. Lives in its own module (rather than a slice)
 * because both the `app` slice and the `auth401modals` slice react to it — a
 * dedicated module keeps the action's ownership in the `app` domain without
 * coupling the two slices to each other.
 */
export const routerLocationChange = createAction(
  "@@router/LOCATION_CHANGE",
  function prepare(location: Location, params: Params<string>) {
    return {
      payload: {
        location,
        params,
        id: nanoid(),
        createdAt: new Date().toISOString()
      }
    };
  }
);
